import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MainService } from 'src/app/services/main.service';
import { MapService } from 'src/app/services/map.service';
import { environment } from 'src/environments/environment';
import * as turf from '@turf/turf';

@Component({
  selector: 'app-graphs-home',
  templateUrl: './graphs-home.component.html',
  styleUrls: ['./graphs-home.component.scss']
})
export class GraphsHomeComponent implements OnInit {

  @Input() capas: any[];
  @Output() capaViz = new EventEmitter<any[]>();
  
  baseUrl =  environment.baseUrl;
  filtroGEP: any[];
  data: any;
  valoresCards=[];
  graphData = {};
  capaSeleccionada = "";
  columnsCapa = [];
  column1 = null;
  column2 = null;
  column3 = null;

  constructor(
    public mapservice: MapService,
    public mainservice: MainService) {
      this.mainservice.filtroGEP$.subscribe( variable =>{
        this.filtroGEP = variable;
        console.log(variable)
        this.init();
      })
    }
  async ngOnInit() {
    await this.mapservice.connect();
    // this.init();
  }

  // async ngOnChanges(changes: SimpleChanges) {
  //   setTimeout(async ()=>{
  //     this.capas = changes.capas.currentValue;
  //     this.init()
  //   },500)
  // }

  async init(){
    setTimeout(async ()=>{
      this.datosCard();
      this.prepareDataGraph();
    },500)
  }

  async datosCard(){

    for(let capa of this.capas){
      this.mapservice.getCardsData(capa.name, capa.cob, this.filtroGEP)
      .then( result => {
            result["data"].map( data => {
              const titulo = this.capas.find(capa => capa.name == data.capa)
              this.valoresCards.push({"titulo": titulo.label, "area": data.value, "descrip": 'En Desarrollo', "medida": data.medida});
            })
      })
    }
  }

  humanize(str) {
    return str
        .replace(/^[\s_]+|[\s_]+$/g, '')
        .replace(/[_\s]+/g, ' ')
        .replace(/^[a-z]/, function(m) { return m.toUpperCase(); });
  }
  

  prepareDataGraph(){
    this.valoresCards.forEach( card => {
      this.graphData[card.capa] = parseFloat(card.valor)
    })
  }

  async fetchCapas(){
    let promises = []
    this.capas.map( capa => {
      promises.push(this.mapservice.CallLayers(capa, this.filtroGEP))
    })

    const response = await Promise.all(promises)
    return response
  }

  async onChangeCapa(capa){
    this.column1 = null;
    this.column2 = null;
    this.column3 = null;
    this.mapservice.getColumnsFromCapas(this.capaSeleccionada).then((columns) => {
      this.columnsCapa = columns.map( col => {
        return {
          value: col,
          text: this.humanize(col)
        }
      });
    });
    this.cambioEnCapa()
  }

  async onChangeColumn(tipo){
    let companies = this.filtroGEP;
    this.mapservice.getDataFromCapa(this.capaSeleccionada, this.column1, this.column2, this.column3, companies).then((data) => {
      this.graphData = data
    })
  }

  cambioEnCapa(){
    console.log(this.capaSeleccionada)
    const capa = this.capas.find( capa => capa.name == this.capaSeleccionada);
    this.mapservice.updateCapaHome(capa)
  }



}
